export default __webpack_public_path__ + "static/media/rules-football-bg.da52fbb2.jpg";